// Swiper carousel library
// https://swiperjs.com/

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// Import styles (Ensure your builder supports this or link them in head)
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const initSwiper = () => {
    const swiperEl = document.querySelector('.swiper');
    if (!swiperEl) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    // v12 Loop Tip: Loop works best if slideCount > slidesPerView * 2
    const enableLoop = slideCount > 6;

    new Swiper('.swiper', {
        modules: [Navigation, Pagination],

        // Essential for modern Swiper performance
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,

        loop: enableLoop,
        slidesPerView: 1.3,
        spaceBetween: 16, // Increased slightly for better visual gap
        centeredSlides: false,

        breakpoints: {
            768:  { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 2.8, spaceBetween: 24 },
            1280: { slidesPerView: 3.8, spaceBetween: 24 },
            1536: { slidesPerView: 4.8, spaceBetween: 24 },
            1800: { slidesPerView: 5.8, spaceBetween: 24 },
        },

        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true, // Clean look for many slides
        },
    });
};

initSwiper();
